import { render, staticRenderFns } from "./AppLayoutEad.vue?vue&type=template&id=60f62b7d"
import script from "./AppLayoutEad.vue?vue&type=script&lang=js"
export * from "./AppLayoutEad.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports